import {dicts} from "../../plugins/dict.js";
import i18nKit from "../../plugins/I18N.js"
let i18n = i18nKit.methods;
import kit from "../../plugins/kit.js"
let api = kit.api;

const columns = [
    {field: 'created', title:i18n.msg('更新时间')},
    {field: 'code', title:i18n.msg('库存编号')},
    {field: 'subCode', title:i18n.msg('子编号')},
    {field: 'inCode', title:i18n.msg('入仓订单')},
    {field: 'thumbId', title:i18n.msg('产品图')},
    {field: 'storeName', title:i18n.msg('所在仓库')},
    {field: 'shelfCode', title:i18n.msg('架位号')},
    {field: 'qty', title:i18n.msg('可用库存')},
    {field: 'storeType', title:i18n.msg('仓储类型')},
    {field: 'status', title:i18n.msg('仓储状态')},
    {field: 'title', title:i18n.msg('货物标题')},
    {field: 'spec', title:i18n.msg('货物规格')},
    {field: 'sku', title:i18n.msg('SKU')},
    {field: 'variationSku', title:i18n.msg('货号')},
    {field: 'price', title:i18n.msg('售价')},
    {field: 'cost', title:i18n.msg('单件成本')},
    {field: 'amostAmount', title:i18n.msg('预估价值')},
    {field: 'cgQty', title:i18n.msg('采购数量')},
    {field: 'ztQty', title:i18n.msg('在途数量')},
    {field: 'totalCount', title:i18n.msg('总库存')},
    // {field: 'totalQty', title:i18n.msg('总数量')},
    {field: 'sevenQty', title:i18n.msg('7天销量')},
    {field: 'monthQty', title:i18n.msg('30天销量')},
    {field: 'safeQty', title:i18n.msg('安全库存')},
    {field: 'productOrigin', title:i18n.msg('采购平台')},
    {field: 'inTime', title:i18n.msg('入仓时间')},
    {field: 'expExpireDate', title:i18n.msg('保管期限')},
    {field: 'backBatch', title:i18n.msg('退件批次')},
    {field: 'backCode', title:i18n.msg('退件单号')},
    {field: 'amtBack', title:i18n.msg('退件费用')},
    {field: 'backAccept', title:i18n.msg('退件受理')},
    {field: 'backReceiver', title:i18n.msg('退件收货人')},
    {field: 'ownerName', title:i18n.msg('归属人')},
    {field: 'companyName', title:i18n.msg('归属公司')},
    {field: 'origin', title:i18n.msg('来源')},
    {field: 'remark1', title:i18n.msg('备注')},
    {field: 'remark2', title:i18n.msg('说明')}
];

const buildColumns = function(h, vue, cols){
    let allColumns = [
        {type: 'checkbox', minWidth: 50 ,fixed: 'left'},
        {field: 'id', title:i18n.msg('ID'), minWidth: 40, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [
                        <span class="id-cell"><i class="view-cell el-icon-edit-outline"></i>{row.id}&nbsp;</span>,
                    ];
                },
            }
        },
        {field: 'created', title:i18n.msg('更新时间'), minWidth: 100, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
        },
        {field: 'code', title:i18n.msg('库存编号'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'subCode', title:i18n.msg('子编号'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'inCode', title:i18n.msg('入仓订单'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'thumbId', title:i18n.msg('产品图'), minWidth: 60, 
              slots: {
                  default: ({row}) => {
                      let id = row.thumbId;
                      return id?[
                          <el-image  style="width: 60px; height: 60px" 
                              src={api.imgView+id} 
                              preview-src-list={[api.imgView+id]}
                              ></el-image>
                      ]: [id];
                  },
              }
        },
        {field: 'storeName', title:i18n.msg('所在仓库'), minWidth: 100, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}    
        },
        {field: 'shelfCode', title:i18n.msg('架位号'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'storeType', title:i18n.msg('仓储类型'), minWidth: 80, sortable: true, 
            slots: {
                default: ({ row }) => {
                    let status = dicts.inventoryStoreTypes.find(d => d.value === row.storeType);
                    return [
                        <div style="text-align:left;">
                            <div>
                                <el-tag size="mini" type={status?status.type:''}>{status?status.label:row.storeType}</el-tag>
                            </div> 
                        </div>
                    ];
                },
            },
            filters:dicts.inventoryStoreTypes,
            formatter:vue.formatStoreType
        },
        {field: 'status', title:i18n.msg('仓储状态'), minWidth: 100, sortable: true, 
            slots: {
                default: ({ row }) => {
                    let status = dicts.inventoryStatuses.find(d => d.value === row.status);
                    return [
                        <div style="text-align:left;">
                            <div> 
                                <span>
                                    <i class="status-cell iconfont icon-trace font11"></i>
                                    <el-button size="mini" plain style="cursor: pointer;" 
                                        onClick={()=> vue.$refs.inventoryTraceRef.showTracks(row.id, row.code)}
                                        type={status?status.type:''}>
                                        {status?status.label:row.status}
                                    </el-button>
                                </span>
                            </div>
                        </div>
                        // <span><i class="status-cell iconfont icon-trace font11"></i><el-tag type={status?status.type:''}>{status?status.label:row.status}</el-tag></span>
                    ];
                },
            },
            filters:dicts.inventoryStatuses,
            formatter:vue.formatStoreStatus
        },
        {field: 'title', title:i18n.msg('货物标题'), minWidth: 60, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'spec', title:i18n.msg('货物规格'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'sku', title:i18n.msg('SKU'), minWidth: 80, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'variationSku', title:i18n.msg('货号'), minWidth: 80, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'price', title:i18n.msg('售价'), minWidth: 60, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [(((row.price / 100.0) || 0).toFixed(2)) || 0 ];
                },
            },
            formatter: function({row}){
                return (((row.price / 100.0) || 0).toFixed(2)) || 0;
            }
        },
        {field: 'qty', title:i18n.msg('可用库存'), minWidth: 60, sortable: true},
        {field: 'cost', title:i18n.msg('单件成本'), minWidth: 60, sortable: true, 
            slots: {
                default: ({row}) => {
                    return ((row.cost / 100.0) || 0).toFixed(2)
                }
            },
            formatter: function({row}){
                return ((row.cost / 100.0) || 0).toFixed(2);
            }
        },
        {field: 'amostAmount', title:i18n.msg('预估价值'), minWidth: 70, sortable: true, 
            slots: {
                default: ({ row }) => {
                    return [(((row.cost * row.qty / 100.0) || 0).toFixed(2)) || 0 ];
                },
            },
            formatter: function({row}){
                return (((row.cost * row.qty / 100.0) || 0).toFixed(2)) || 0 ;
            }
        },
        {field: 'cgQty', title:i18n.msg('采购数量'), minWidth: 60, sortable: true},
        {field: 'ztQty', title:i18n.msg('在途数量'), minWidth: 60, sortable: true},
        {field: 'totalCount', title:i18n.msg('总库存'), minWidth: 60, sortable: true},
        // {field: 'totalQty', title:i18n.msg('总数量'), minWidth: 60, sortable: true},
        {field: 'sevenQty', title:i18n.msg('7天销量'), minWidth: 60, sortable: true},
        {field: 'monthQty', title:i18n.msg('30天销量'), minWidth: 60, sortable: true},
        {field: 'safeQty', title:i18n.msg('安全库存'), minWidth: 60, sortable: true},
        {field: 'productOrigin', title:i18n.msg('采购平台'), minWidth: 80, sortable: true,
            slots: {
                default: ({ row }) => {
                    let status = dicts.productOrigin.find(d => d.value === row.productOrigin);
                    let link = row.productLink;
                    return [
                        <div style="text-align:left;">
                            <div>
                                {row.productOrigin
                                ?
                                <span><el-link href={link} target="_blank" icon="el-icon-link"></el-link>
                                <el-tag size="mini" type={status?status.type:''}>{status?status.label:''}</el-tag></span>
                                :''}
                            </div> 
                        </div>
                    ];
                },
            },
            filters:dicts.productOrigin,
            formatter:vue.formatOrigin
        },
        {field: 'inTime', title:i18n.msg('入仓时间'), minWidth: 100, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
        },
        {field: 'expExpireDate', title:i18n.msg('保管期限'), minWidth: 100, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
        },
        {field: 'backBatch', title:i18n.msg('退件批次'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'backCode', title:i18n.msg('退件单号'), minWidth: 100, sortable: true,
            slots: {
                default: ({row}) => {
                    return [
                        <div>
                            {row.backCode?
                                (
                                <span>
                                    <a target="_blank" href={'https://www.baidu.com/s?wd='+row.backCode}><i class="el-icon-link"></i></a>
                                    {row.backCode}
                                </span>
                                )
                                :
                                ""
                            }
                        </div>
                    ]
                }
            },
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'amtBack', title:i18n.msg('退件费用'), minWidth: 60, sortable: true, 
            slots: {
                default: ({row}) => {
                    return ((row.amtBack / 100.0) || 0).toFixed(2)
                }
            },
            formatter: function({row}){
                return ((row.amtBack / 100.0) || 0).toFixed(2);
            }
        },
        {field: 'backAccept', title:i18n.msg('退件受理'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'backReceiver', title:i18n.msg('退件收货人'), minWidth: 100, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'ownerName', title:i18n.msg('归属人'), minWidth: 80, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'companyName', title:i18n.msg('归属公司'), minWidth: 80, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'origin', title:i18n.msg('来源'), minWidth: 80, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'remark1', title:i18n.msg('备注'), minWidth: 80, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'remark2', title:i18n.msg('说明'), minWidth: 80, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        }
    ];

    let showCols = [
        {type: 'checkbox', minWidth: 50 ,fixed: 'left'},
        {field: 'id', title:i18n.msg('ID'), minWidth: 100, sortable: true,
            slots: {
                default: ({ row }) => {
                    return [
                        <span class="id-cell"><i class="edit-cell el-icon-edit-outline"></i>{row.id}&nbsp;</span>,
                    ];
                },
            }
        },
    ]

    if(cols && cols.length>0){
        cols.forEach(f => {
            let col = allColumns.find(c => c.field == f.field);
            if(col){
                showCols.push(col);
            }
        });
    }else{
        allColumns.forEach(col => showCols.push(col));
    }
    // let columnsStr = localStorage.getItem("order-columns")
  
    return showCols;
}

export default {
    allColumns: columns,
    buildColumns : buildColumns
}